import { ListViewBitFlagsMasks, setBit } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { getCurrentLazyDensity } from 'owa-fabric-densities';
import { changeDensity } from 'owa-fabric-theme';
import type DisplayDensityMode from 'owa-service/lib/contract/DisplayDensityMode';
import {
    getUserConfiguration,
    lazyUpdateUserConfigurationService,
    updateUserConfigurationAndService,
} from 'owa-session-store';
import { UpdateUserConfigurationEntry } from 'shared/internal/owa-service/src/types/UpdateUserConfigurationEntry';
import densityOptionSelectedValue from '../utils/densityOptionSelectedValue';
import { SecondaryDensitySettings } from '../utils/getSecondarySettingDefaultsForMode';

export async function saveDensityOption(
    displayDensityMode: DisplayDensityMode,
    secondarySettings?: SecondaryDensitySettings
) {
    const userOptions = getUserConfiguration().UserOptions;

    const lazyDensity = getCurrentLazyDensity(displayDensityMode);
    if (lazyDensity) {
        const density = await lazyDensity.import();
        changeDensity(displayDensityMode, density);
    }

    if (secondarySettings) {
        setBit(secondarySettings.hideSenderImage, ListViewBitFlagsMasks.HideSenderImage);
    }

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (33,59): Object is possibly 'undefined'.
    // @ts-expect-error
    const displayDensityChanging = displayDensityMode !== userOptions.DisplayDensityMode;
    const showInlinePreviewChanging =
        secondarySettings &&
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (39,51): Object is possibly 'undefined'.
        // @ts-expect-error
        secondarySettings.enableInlinePreview !== userOptions.ShowInlinePreviews;

    if (displayDensityChanging || showInlinePreviewChanging) {
        const updates: UpdateUserConfigurationEntry<'OWA.UserOptions'>[] = [];
        if (displayDensityChanging) {
            updates.push({
                key: 'DisplayDensityMode',
                valuetype: 'Integer32',
                value: [String(densityOptionSelectedValue(displayDensityMode))],
            });
        }
        if (showInlinePreviewChanging) {
            updates.push({
                key: 'ShowInlinePreviews',
                valuetype: 'Boolean',
                value: [String(secondarySettings.enableInlinePreview)],
            });
        }

        await updateUserConfigurationAndService(config => {
            if (displayDensityChanging) {
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2532 (63,17): Object is possibly 'undefined'.
                // @ts-expect-error
                config.UserOptions.DisplayDensityMode = displayDensityMode;
            }
            if (showInlinePreviewChanging) {
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2532 (69,17): Object is possibly 'undefined'.
                // @ts-expect-error
                config.UserOptions.ShowInlinePreviews = secondarySettings.enableInlinePreview;
            }
        }, updates);
    }

    if (secondarySettings) {
        await lazyUpdateUserConfigurationService.importAndExecute(
            [
                {
                    key: 'ListViewBitFlags',
                    valuetype: 'Integer32',
                    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                    // -> Error TS2532 (83,36): Object is possibly 'undefined'.
                    // @ts-expect-error
                    value: [String(getUserConfiguration().ViewStateConfiguration.ListViewBitFlags)],
                },
            ],
            'OWA.ViewStateConfiguration'
        );
    }
}
